$(document).ready(function() {

    $('.btn-options--delete').on('click', function() {
        var parent_item = $(this).parent().closest('.product-item');
        var parent_form = $('.checklist-item-form');
        var delete_text = $('.delete-title', parent_item).text();
        var post_id = $("input[name='checklist-item-id']", parent_form).val();
        $("input[name='checklist-id']").val(post_id);
        $('.delete-item-description').text(delete_text);
    })

})